import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import queryString from 'query-string'

export function useResetPageOnEmptyResults(results: any[] | undefined, isError: boolean = false) {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (results && results.length === 0 && location.search) {
      const params = queryString.parse(location.search)
      const current = parseInt(params.page as string) || 1
      // reset page to 1 if results are empty and queryString page param is not empty
      if (current !== 1) {
        history.replace({
          ...location,
          search: queryString.stringify({ ...params, page: '1' }),
        })
      }
    } else if ((!results || isError) && location.search) {
      const params = queryString.parse(location.search)
      const current = parseInt(params.page as string)
       // api error due to bad request because of invalid page number
      if (current < 1 || isNaN(current)) {
        history.replace({
          ...location,
          search: queryString.stringify({ ...params, page: '1' }),
        })
      }
    }
  }, [results, history, location])
}
